import { render, staticRenderFns } from "./officeType.vue?vue&type=template&id=09b9fb68&scoped=true"
import script from "./officeType.vue?vue&type=script&lang=js"
export * from "./officeType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09b9fb68",
  null
  
)

export default component.exports